import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageComments300x250Fs from './freestar/MobileDevPageComments300x250';
import MobileDevPageComments300x250Tab from './taboola/MobileDevPageComments300x250';
const MobileDevPageComments300x250 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(MobileDevPageComments300x250Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageComments300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageComments300x250.displayName = 'MobileDevPageComments300x250';
export default MobileDevPageComments300x250;
